import PropTypes from 'prop-types';
import React, {
  useEffect,
  useState,
  useRef,
} from 'react';

import { Map } from 'immutable';

import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import FormControl   from '@mui/material/FormControl';
import InputLabel    from '@mui/material/InputLabel';

// import debounce from 'helpers/debounce';

import intlTelInput from 'intl-tel-input';
import utils        from 'intl-tel-input/build/js/utils';
import parsePhoneNumber from 'libphonenumber-js'

import './IntlTelInput.scss';
import 'intl-tel-input/build/css/intlTelInput.css';

function GenericIntlTelInput({
  name, id, label, initialCountry, disabled, onChange, value, size="md"
}) {

  const inputRef = useRef();

  const [state, setState] = useState(new Map());
  const localValue = state.get('localValue', '');

  const itiObj = state.get('itiObj', undefined);

  useEffect(() => {
    if (value && itiObj) {
      const number = value.startsWith('+') ? value : `+${value}`;
      const phone = parsePhoneNumber(number);

      if (phone && phone.isPossible()) {
        itiObj.setNumber(number);
        setState(state.set('localValue', phone.formatNational().replaceAll(' ', '')));
      }
    }
  }, [value, itiObj, state]);

  useEffect(() => {
    const iti = intlTelInput(inputRef.current, {
      utilsScript:        utils,
      separateDialCode:   true,
      initialCountry:     initialCountry,
      preferredCountries: [initialCountry],
      formatOnDisplay:    false,
    });

    iti.promise.then(() => {
      setState(state.set('itiObj', iti));
    });
  }, []);

  useEffect(() => {
    if (itiObj === undefined) return;

    inputRef.current.addEventListener('countrychange', (e) => {
      const element = { target: { name: e.target.name, value: `+${itiObj.getNumber().replace(/\D+/g, '')}` } };
      setState(state.set('localValue', e.target.value.replace(/\D+/g, '')));

      onChange(element);
    });
  }, [itiObj]);

  const onPhoneChange = (e) => {
    // debounce(() => {
    //   const element = { target: { name: e.target.name, value: itiObj.getNumber() } };
    //   onChange(element);
    // }, 1, 'set-phone');
    const element = { target: { name: e.target.name, value: `+${itiObj.getNumber().replace(/\D+/g, '')}` } };
    setState(state.set('localValue', e.target.value.replace(/\D+/g, '')));

    onChange(element);
  };

  const fieldStyle = {
    'input:-webkit-autofill': {
      boxShadow: '0 0 0 50px white inset',
    },
    'input:-webkit-autofill:focus': {
      boxShadow: '0 0 0 50px white inset',
    },
  };

  if (!label) {
    fieldStyle['& legend'] = { display: 'none' };
    fieldStyle['& fieldset'] = { top: 0 };
  }

  return (
    <FormControl fullWidth>
      <InputLabel
        htmlFor={id}
        size={size}
        sx={{
          ml:              10,
          backgroundColor: 'background.paper',

          '&.Mui-focused, &.MuiInputLabel-shrink': {
            ml: 0,
            px: 1,
          },
        }}
      >
        {label}
      </InputLabel>
      <OutlinedInput
        id={id}
        name={name}
        size={size}
        inputRef={inputRef}
        onChange={onPhoneChange}
        value={localValue}
        fullWidth
        disabled={disabled}
        sx={fieldStyle}
        data-testid="intltelinput-number-input"
      />
    </FormControl>
  );
}

GenericIntlTelInput.defaultProps = {
  name:           null,
  id:             null,
  label:          null,
  initialCountry: '',
  disabled:       false,
  onChange:       null,
};

GenericIntlTelInput.propTypes = {
  name:           PropTypes.string,
  id:             PropTypes.string,
  label:          PropTypes.string,
  initialCountry: PropTypes.string,
  disabled:       PropTypes.bool,
  onChange:       PropTypes.func,
};

export default GenericIntlTelInput;
